import { useConfig } from '../../config';
import { LinkListing } from '../LinkListing/LinkListing';
import './AlphabeticListing.css';

export const AlphabeticListing = ({
	links,
	removeEmpty = false,
	isDense = false,
}: {
	links: { id?: string; name: string; url: string }[];
	removeEmpty?: boolean;
	isDense?: boolean;
}): JSX.Element => {
	const { alphabet, locale } = useConfig();

	const sortedLinks = [...links].sort((a, b) => {
		const nameA = a.name.toUpperCase();
		const nameB = b.name.toUpperCase();

		const isLetter = (char: string) => /^[A-ZÅÄÖ]$/.test(char);

		const firstCharA = nameA.charAt(0);
		const firstCharB = nameB.charAt(0);

		const isA_Letter = isLetter(firstCharA);
		const isB_Letter = isLetter(firstCharB);

		if (isA_Letter && isB_Letter) {
			return nameA.localeCompare(nameB, locale, { sensitivity: 'base' });
		}

		if (isA_Letter) return -1;

		if (isB_Letter) return 1;

		return nameA.localeCompare(nameB, locale, { sensitivity: 'base' });
	});

	let letterGroups = alphabet.split('').map((letter) => ({
		letter,
		items: sortedLinks.filter((b) => b.name.charAt(0).toUpperCase() === letter),
	}));

	const groupedNames = letterGroups.flatMap((group) => group.items.map((e) => e.name));
	const otherItems = sortedLinks.filter((e) => !groupedNames.includes(e.name));

	const specialCharacterGroup = { letter: '#', items: otherItems };

	if (removeEmpty) {
		letterGroups = letterGroups.filter((group) => group.items.length);
	}
	letterGroups.push(specialCharacterGroup);

	return (
		<div className="alphabetic-listing">
			{letterGroups.map((group, index) => (
				<div key={group.letter}>
					{!isDense && <h2 className="title">{group.letter}</h2>}
					<LinkListing
						isDense={isDense}
						showBorder={!isDense && letterGroups.length > 1 && letterGroups.length - 1 !== index}
						links={group.items.map((e) => ({
							url: e.url,
							text: e.name,
							key: e.id || e.name,
						}))}
					/>
				</div>
			))}
		</div>
	);
};
